import { Component, OnInit } from "@angular/core";
import { Form } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { FormService } from "../../../@core/api/form.service";
import { OfferService } from "../../../@core/api/offer.service";
import { Offer } from "../../../@core/data/offer";

@Component({
  selector: "ngx-offer-new",
  templateUrl: "./offer-new.component.html",
  styleUrls: ["./offer-new.component.scss"],
})
export class OfferNewComponent implements OnInit {
  offer: Offer = {
    id: "",
    formId: "",
    payoff: ""
  };
  forms: any;
  countryCodes: any[] = [];
  loading: boolean = false;
  id: string;
  pagination = {
    perPage: 100,
    pageNumber: 0,
  };
  order = {
    field: "timestamp",
    direction: "desc",
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private offerService: OfferService,
    private formService: FormService
  ) {}

  async ngOnInit() {
    let id = this.route.snapshot.params["id"];    
    this.forms = await this.formService.getForms(this.pagination,undefined,this.order)
    if (id) {
      this.loading = true;
      this.id = id;
      this.offer = <Offer>await this.offerService.getOffer(id);
    }

    this.loading = false;
  }

  addTag() {
    if (this.offer.tags) {
      this.offer.tags.push("");
    } else {
      this.offer.tags = [""];
    }
  }

  editTag(e, i) {
    this.offer.tags[i] = e.target.value;
    console.log(this.offer.tags);
  }

  removeTag(i) {
    console.log(i);

    console.log(this.offer.tags);
    this.offer.tags.splice(i, 1);
  }

  async save() {
    if (this.id) {
      try {
        await this.offerService.editOffer(this.offer, this.id);
        this.router.navigate(["home", "offers"]);
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        let data = <any>(
          await this.offerService.createOffer(this.offer)
        );
        this.id = data.id;
        this.router.navigate(["home", "offers"]);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
